import { render, staticRenderFns } from "./OcrExpenseAccount.vue?vue&type=template&id=bd078992&"
import script from "./OcrExpenseAccount.vue?vue&type=script&lang=js&"
export * from "./OcrExpenseAccount.vue?vue&type=script&lang=js&"
import style0 from "./OcrExpenseAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports